<div class="batch-session-details-dialog">
  
  <!-- Header -->
  <div class="flex items-center justify-between p-6 border-b border-gray-200 dark:border-gray-700">
    <div>
      <h2 class="text-2xl font-bold text-gray-900 dark:text-white">
        Szczegóły Sesji Batch
      </h2>
      <p class="text-sm text-gray-600 dark:text-gray-400 mt-1" *ngIf="session">
        {{ session.sessionRef }}
      </p>
    </div>
    <button mat-icon-button (click)="close()">
      <mat-icon [svgIcon]="'tabler_outline:x'"></mat-icon>
    </button>
  </div>

  <!-- Loading -->
  <div *ngIf="isLoading" class="flex items-center justify-center py-12">
    <mat-spinner [diameter]="60"></mat-spinner>
  </div>

  <!-- Content -->
  <div *ngIf="!isLoading && session" class="p-6">
    
    <!-- Session Info Cards -->
    <div class="grid grid-cols-1 md:grid-cols-4 gap-4 mb-6">
      <div [ngClass]="getStatusCardClass(session.status)" class="rounded-lg p-4">
        <div class="text-sm font-medium opacity-80">Status</div>
        <div class="text-xl font-bold capitalize mt-1">
          {{ session.status }}
        </div>
      </div>

      <div class="bg-purple-50 dark:bg-purple-900/20 border border-purple-200 dark:border-purple-800 rounded-lg p-4">
        <div class="text-sm text-purple-800 dark:text-purple-300">Faktury</div>
        <div class="text-xl font-bold text-purple-900 dark:text-purple-200">
          {{ session.invoiceCount }}
        </div>
      </div>

      <div class="bg-green-50 dark:bg-green-900/20 border border-green-200 dark:border-green-800 rounded-lg p-4">
        <div class="text-sm text-green-800 dark:text-green-300">Sukces</div>
        <div class="text-xl font-bold text-green-900 dark:text-green-200">
          {{ session.successfulInvoices }}
        </div>
      </div>

      <div class="bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 rounded-lg p-4">
        <div class="text-sm text-red-800 dark:text-red-300">Błędy</div>
        <div class="text-xl font-bold text-red-900 dark:text-red-200">
          {{ session.failedInvoices }}
        </div>
      </div>
    </div>

    <!-- Alert dla sesji z błędem -->
    <div *ngIf="canResendSession()" class="bg-yellow-50 dark:bg-yellow-900/20 border border-yellow-200 dark:border-yellow-800 rounded-lg p-4 mb-6 flex items-center justify-between">
      <div class="flex items-center">
        <mat-icon [svgIcon]="'tabler_outline:alert-triangle'" class="text-yellow-600 dark:text-yellow-400 mr-3"></mat-icon>
        <div>
          <div class="text-sm font-medium text-yellow-900 dark:text-yellow-200">
            Sesja zakończona błędem
          </div>
          <div class="text-xs text-yellow-700 dark:text-yellow-300 mt-1">
            Możesz wysłać ponownie wszystkie faktury lub pojedyncze faktury z tej sesji
          </div>
        </div>
      </div>
      <button mat-raised-button color="warn" (click)="resendAllInvoices()" [disabled]="isResendingAll">
        <mat-icon [svgIcon]="isResendingAll ? 'tabler_outline:loader' : 'tabler_outline:refresh'" class="mr-2"></mat-icon>
        {{ isResendingAll ? 'Wysyłanie...' : 'Wyślij ponownie wszystkie' }}
      </button>
    </div>

    <!-- Tabs -->
    <mat-tab-group>
      
      <!-- Faktury Tab -->
      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon class="mr-2" [svgIcon]="'tabler_outline:file-invoice'"></mat-icon>
          Faktury ({{ invoices.length }})
        </ng-template>

        <div class="mt-4">
          <div class="bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700 overflow-hidden">
            <table mat-table [dataSource]="invoicesDataSource" class="w-full">
              
              <!-- Document Number -->
              <ng-container matColumnDef="documentNumber">
                <th mat-header-cell *matHeaderCellDef>Numer</th>
                <td mat-cell *matCellDef="let invoice">
                  <div class="text-sm font-medium text-gray-900 dark:text-white">
                    {{ invoice.documentNumber }}
                  </div>
                  <div class="text-xs text-gray-500 dark:text-gray-400">
                    {{ invoice.documentType }}
                  </div>
                </td>
              </ng-container>

              <!-- Document Type -->
              <ng-container matColumnDef="documentType">
                <th mat-header-cell *matHeaderCellDef>Typ</th>
                <td mat-cell *matCellDef="let invoice">
                  <div class="text-sm text-gray-700 dark:text-gray-300">
                    {{ invoice.documentType }}
                  </div>
                </td>
              </ng-container>

              <!-- Status -->
              <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef>Status</th>
                <td mat-cell *matCellDef="let invoice">
                  <div [ngClass]="getInvoiceStatusBadgeClass(invoice)" class="inline-flex items-center px-2.5 py-1 rounded-full text-xs font-semibold">
                    <mat-icon [svgIcon]="getInvoiceStatusIcon(invoice)" class="mr-1" style="width: 14px; height: 14px;"></mat-icon>
                    <span *ngIf="invoice.ksefSent">Wysłana</span>
                    <span *ngIf="invoice.ksefError">Błąd</span>
                    <span *ngIf="invoice.ksefPendingSend && !invoice.ksefSent && !invoice.ksefError">Oczekuje</span>
                  </div>
                </td>
              </ng-container>

              <!-- KSeF Number -->
              <ng-container matColumnDef="ksefNumber">
                <th mat-header-cell *matHeaderCellDef>Numer KSeF</th>
                <td mat-cell *matCellDef="let invoice">
                  <div class="text-sm font-mono text-gray-700 dark:text-gray-300">
                    {{ invoice.ksefNumber || '-' }}
                  </div>
                </td>
              </ng-container>

              <!-- Error -->
              <ng-container matColumnDef="error">
                <th mat-header-cell *matHeaderCellDef>Błąd</th>
                <td mat-cell *matCellDef="let invoice">
                  <div *ngIf="invoice.ksefError" class="text-sm">
                    <span class="inline-flex items-center px-2 py-0.5 rounded bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-300 font-semibold text-xs mb-1">
                      {{ invoice.ksefError.code }}
                    </span>
                    <div class="text-xs text-gray-600 dark:text-gray-400 mt-1">{{ invoice.ksefError.message }}</div>
                  </div>
                  <div *ngIf="!invoice.ksefError" class="text-gray-400">-</div>
                </td>
              </ng-container>

              <!-- Actions -->
              <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef>Akcje</th>
                <td mat-cell *matCellDef="let invoice">
                  <button 
                    mat-icon-button 
                    color="primary"
                    (click)="resendSingleInvoice(invoice)" 
                    [disabled]="isResendingInvoice(invoice.id) || invoice.ksefSent || invoice.isDeleted"
                    [matTooltip]="invoice.isDeleted ? 'Dokument został usunięty' : (invoice.ksefSent ? 'Faktura została wysłana' : 'Wyślij ponownie')">
                    <mat-icon [svgIcon]="isResendingInvoice(invoice.id) ? 'tabler_outline:loader' : (invoice.isDeleted ? 'tabler_outline:trash' : 'tabler_outline:send')"></mat-icon>
                  </button>
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="invoicesColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: invoicesColumns;"></tr>
            </table>
          </div>
        </div>
      </mat-tab>

      <!-- Timeline Tab -->
      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon class="mr-2" [svgIcon]="'tabler_outline:timeline'"></mat-icon>
          Timeline ({{ timeline.length }})
        </ng-template>

        <div class="mt-4">
          <div class="space-y-4">
            <div *ngFor="let event of timeline" class="flex gap-4 p-4 bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700">
              <!-- Icon -->
              <div class="flex-shrink-0">
                <div class="w-10 h-10 rounded-full bg-blue-100 dark:bg-blue-900/30 flex items-center justify-center">
                  <mat-icon [svgIcon]="getEventIcon(event.event)" class="text-blue-600 dark:text-blue-400"></mat-icon>
                </div>
              </div>

              <!-- Content -->
              <div class="flex-1">
                <div class="flex items-start justify-between">
                  <div>
                    <h4 class="text-sm font-medium text-gray-900 dark:text-white">
                      {{ getEventLabel(event.event) }}
                    </h4>
                    <p class="text-xs text-gray-500 dark:text-gray-400 mt-1">
                      {{ event.timestamp | date:'dd.MM.yyyy HH:mm:ss' }}
                    </p>
                  </div>
                </div>

                <!-- Details -->
                <div *ngIf="event.details" class="mt-2 text-xs text-gray-600 dark:text-gray-400">
                  <pre class="whitespace-pre-wrap font-mono bg-gray-50 dark:bg-gray-900 p-2 rounded">{{ event.details | json }}</pre>
                </div>
              </div>
            </div>
          </div>
        </div>
      </mat-tab>

      <!-- Statystyki Tab -->
      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon class="mr-2" [svgIcon]="'tabler_outline:chart-bar'"></mat-icon>
          Statystyki
        </ng-template>

        <div class="mt-4">
          <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div class="p-4 bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700">
              <h3 class="text-sm font-medium text-gray-900 dark:text-white mb-3">Podsumowanie</h3>
              <dl class="space-y-2">
                <div class="flex justify-between text-sm">
                  <dt class="text-gray-600 dark:text-gray-400">Utworzona:</dt>
                  <dd class="text-gray-900 dark:text-white font-medium">{{ session.createdAt | date:'dd.MM.yyyy HH:mm:ss' }}</dd>
                </div>
                <div class="flex justify-between text-sm">
                  <dt class="text-gray-600 dark:text-gray-400">Zamknięta:</dt>
                  <dd class="text-gray-900 dark:text-white font-medium">{{ session.closedAt | date:'dd.MM.yyyy HH:mm:ss' }}</dd>
                </div>
                <div class="flex justify-between text-sm">
                  <dt class="text-gray-600 dark:text-gray-400">Zakończona:</dt>
                  <dd class="text-gray-900 dark:text-white font-medium">{{ session.completedAt | date:'dd.MM.yyyy HH:mm:ss' }}</dd>
                </div>
                <div class="flex justify-between text-sm">
                  <dt class="text-gray-600 dark:text-gray-400">Czas przetwarzania:</dt>
                  <dd class="text-gray-900 dark:text-white font-medium">{{ formatProcessingTime(session.totalProcessingTime) }}</dd>
                </div>
                <div class="flex justify-between text-sm">
                  <dt class="text-gray-600 dark:text-gray-400">Prób sprawdzenia:</dt>
                  <dd class="text-gray-900 dark:text-white font-medium">{{ session.checkAttempts }}</dd>
                </div>
              </dl>
            </div>

            <div class="p-4 bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700">
              <h3 class="text-sm font-medium text-gray-900 dark:text-white mb-3">Faktury</h3>
              <dl class="space-y-2">
                <div class="flex justify-between text-sm">
                  <dt class="text-gray-600 dark:text-gray-400">Wszystkie:</dt>
                  <dd class="text-gray-900 dark:text-white font-medium">{{ stats.totalInvoices }}</dd>
                </div>
                <div class="flex justify-between text-sm">
                  <dt class="text-gray-600 dark:text-gray-400">Wysłane (z nr KSeF):</dt>
                  <dd class="text-green-600 dark:text-green-400 font-medium">{{ stats.withKsefNumber }}</dd>
                </div>
                <div class="flex justify-between text-sm">
                  <dt class="text-gray-600 dark:text-gray-400">Z błędami:</dt>
                  <dd class="text-red-600 dark:text-red-400 font-medium">{{ stats.errors }}</dd>
                </div>
                <div class="flex justify-between text-sm">
                  <dt class="text-gray-600 dark:text-gray-400">Oczekujące:</dt>
                  <dd class="text-yellow-600 dark:text-yellow-400 font-medium">{{ stats.pending }}</dd>
                </div>
              </dl>
            </div>
          </div>
        </div>
      </mat-tab>

    </mat-tab-group>

  </div>

  <!-- Footer -->
  <div class="flex justify-end gap-3 p-6 border-t border-gray-200 dark:border-gray-700">
    <button mat-button (click)="close()">Zamknij</button>
  </div>

</div>

